import axios from "@/utils/axios";

export interface CreateCheckoutSessionRequest {
	priceId: string;
}

export interface CreateCustomerPortalSessionRequest {
	priceId: string | null;
}

export interface CreateCheckoutSessionResponse {
	sessionId: string;
}

export interface CreateBillingPortalSessionResponse {
	sessionUrl: string;
}


export interface SetupResponse {
	publishableKey: string;
	rare: SetupResponse.ProductResponse;
	epic: SetupResponse.ProductResponse;
	legendary: SetupResponse.ProductResponse;
}

export namespace SetupResponse {
	export interface ProductResponse {
		id: string;
		name: string;
		prices: SetupResponse.ProductResponse.PriceResponse[];
	}

	export namespace ProductResponse {
		export interface PriceResponse {
			id: string;
			pricePerMonth: number;
			pricePerPeriod: number;
			periodInMonths: number;
			currency: string;
		}
	}
}

export default {
	async getSetup(): Promise<SetupResponse> {
		return (await axios().get("/stripe/setup/")).data;
	},
	async createCheckoutSession(payload: CreateCheckoutSessionRequest): Promise<CreateCheckoutSessionResponse> {
		return (await axios().post("/stripe/session/", payload)).data;
	},
	async createCustomerPortal(payload: CreateCustomerPortalSessionRequest): Promise<CreateBillingPortalSessionResponse> {
		return (await axios().post("/stripe/customer-portal/", payload)).data;
	},
};